import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { SessionService } from "./session.service";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmComponent } from "../shared/components/confirm-generic/confirm.component";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  private dialog = inject(MatDialog);
  private translate = inject(TranslateService);
  constructor(private routes: Router, private sessionService: SessionService) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const isSignedIn = await this.sessionService.isUserLoggedIn();

    if (!isSignedIn) {
      const shouldPreserveUrl = state.url.includes("store/link");

      if (shouldPreserveUrl) {
        localStorage.setItem("redirectUrl", state.url);
        const message = await firstValueFrom<string>(
          this.translate.get(
            "messages.You need to sign in before linking your store. The process will automatically continue once you're signed in."
          )
        );
        this.dialog.open(ConfirmComponent, {
          data: {
            message: message,
          },
        });
      }

      this.routes.navigate(["/authentication/login"]);
      return false;
    }

    return true;
  }
}
